import { render, staticRenderFns } from "./TransactionTaxDisplay.vue?vue&type=template&id=e5da92fe&scoped=true&"
import script from "./TransactionTaxDisplay.vue?vue&type=script&lang=js&"
export * from "./TransactionTaxDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5da92fe",
  null
  
)

export default component.exports